






















import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    execLabel: String,
    cancelLabel: {
      type: String,
      default: "キャンセル"
    },
    title: String,
    active: Boolean,
    closeOnExec: {
      type: Boolean,
      default: true
    },
    errors: Object as PropType<Record<string, unknown>>,
    hasExecution: {
      type: Boolean,
      default: true
    },
    hasCancellation: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isExecutionSuspended: false
    };
  },
  methods: {
    exec() {
      this.suspendExecuteButton();
      this.$emit("exec", () => {
        if (this.closeOnExec) {
          this.$emit("update:active", false);
        }
        this.resumeExecuteButton();
      });
    },
    suspendExecuteButton() {
      this.isExecutionSuspended = true;
    },
    resumeExecuteButton() {
      this.isExecutionSuspended = false;
    }
  }
});
